import React from 'react';

export const HeaderCompDocument = () => {
  return(
    <div className="card border-0 rounded-0">
      <div className="container py-4">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
            <h3>Document</h3>
          </div>
        </div>
      </div>
    </div>
  );
};